import { colors } from '../../config/colors';

export function buildLandingMapMarkers(t) {
  return [
    {
      id: 'facility-paris',
      position: [48.8566, 2.3522],
      title: t('landingDemoMarkerFacility'),
      subtitle: t('landingDemoMarkerFacilitySub'),
      iconColor: colors.brand[500],
      legendType: 'own',
    },
    {
      id: 'supplier-berlin',
      position: [52.52, 13.405],
      title: t('landingDemoMarkerSupplier'),
      subtitle: t('landingDemoMarkerSupplierSub'),
      iconColor: colors.secondary[500],
      legendType: 'supplier',
    },
    {
      id: 'supplier-london',
      position: [51.5074, -0.1278],
      title: t('landingDemoMarkerSupplier2'),
      subtitle: t('landingDemoMarkerSupplier2Sub'),
      iconColor: colors.secondary[500],
      legendType: 'supplier',
    },
    {
      id: 'geo-taiwan',
      position: [23.6978, 120.9605],
      title: t('landingDemoMarkerGeography'),
      subtitle: t('landingDemoMarkerGeographySub'),
      iconColor: colors.info[500],
      legendType: 'geography',
    },
    {
      id: 'port-rotterdam',
      position: [51.9225, 4.4792],
      title: t('landingDemoMarkerPort'),
      subtitle: t('landingDemoMarkerPortSub'),
      iconColor: colors.brand[500],
      legendType: 'own',
    },
  ];
}

export function buildLandingMapRoutes() {
  return [
    {
      id: 'route-logistics',
      type: 'logistics',
      positions: [
        [48.8566, 2.3522],
        [51.9225, 4.4792],
        [51.5074, -0.1278],
        [40.7128, -74.006],
      ],
    },
    {
      id: 'route-graph',
      type: 'graph',
      positions: [
        [52.52, 13.405],
        [48.8566, 2.3522],
        [51.9225, 4.4792],
      ],
    },
  ];
}

export const LANDING_ROUTE_DEMO = {
  riskScore: 62,
  isActive: true,
};

export const LANDING_RISK_DEMO = {
  overallScore: 68,
  supplyChain: 72,
  industry: 55,
  newsSentiment: 63,
  confidence: 84,
};

export const LANDING_ROUTE_RISK_DEMO = {
  riskScore: 58,
  distanceKm: 5840,
  durationMinutes: 4320,
  costUsd: 12400,
};

export const LANDING_GLOBAL_ALERTS = [
  { id: 'alert-1', severity: 'high', titleKey: 'landingDemoAlert1Title', descKey: 'landingDemoAlert1Desc' },
  { id: 'alert-2', severity: 'medium', titleKey: 'landingDemoAlert2Title', descKey: 'landingDemoAlert2Desc' },
  { id: 'alert-3', severity: 'critical', titleKey: 'landingDemoAlert3Title', descKey: 'landingDemoAlert3Desc' },
];

/** Static country sentiment tones — names match world-atlas@2 country labels (same as Dashboard GDELT map). */
export const LANDING_COUNTRY_SENTIMENTS = [
  { Country: 'France', Tone: 1.8, SentimentLabel: 'Neutral' },
  { Country: 'Germany', Tone: 4.5, SentimentLabel: 'Positive' },
  { Country: 'United Kingdom', Tone: 3.2, SentimentLabel: 'Positive' },
  { Country: 'Netherlands', Tone: 2.4, SentimentLabel: 'Neutral' },
  { Country: 'United States of America', Tone: -0.8, SentimentLabel: 'Neutral' },
  { Country: 'China', Tone: -3.6, SentimentLabel: 'Negative' },
  { Country: 'Taiwan', Tone: -5.1, SentimentLabel: 'Very Negative' },
  { Country: 'Ukraine', Tone: -6.4, SentimentLabel: 'Very Negative' },
  { Country: 'Brazil', Tone: -2.2, SentimentLabel: 'Negative' },
  { Country: 'India', Tone: 0.6, SentimentLabel: 'Neutral' },
  { Country: 'Japan', Tone: 2.8, SentimentLabel: 'Positive' },
  { Country: 'Russia', Tone: -4.2, SentimentLabel: 'Negative' },
];

export function buildLandingWorldMapMarkers(t) {
  return [
    { id: 'paris', coordinates: [2.3522, 48.8566], label: t('landingDemoMarkerFacility'), riskScore: 68 },
    { id: 'berlin', coordinates: [13.405, 52.52], label: t('landingDemoMarkerSupplier'), riskScore: 55 },
    { id: 'london', coordinates: [-0.1278, 51.5074], label: t('landingDemoMarkerSupplier2'), riskScore: 42 },
    { id: 'taiwan', coordinates: [120.9605, 23.6978], label: t('landingDemoMarkerGeography'), riskScore: 74 },
    { id: 'rotterdam', coordinates: [4.4792, 51.9225], label: t('landingDemoMarkerPort'), riskScore: 38 },
  ];
}

export function buildLandingWorldMapRoutes() {
  return [
    {
      id: 'route-eu-us',
      from: [2.3522, 48.8566],
      to: [-74.006, 40.7128],
      isActive: true,
    },
    {
      id: 'route-eu-graph',
      from: [13.405, 52.52],
      to: [4.4792, 51.9225],
      isActive: true,
    },
  ];
}

export function getSentimentColorForTone(tone) {
  if (tone > 5) return colors.success[500];
  if (tone > 2) return colors.success[400];
  if (tone >= -2) return colors.warning[500];
  if (tone >= -5) return colors.danger[400];
  return colors.danger[600];
}

export function getCountryFillForSentiment(countryName, sentiments = LANDING_COUNTRY_SENTIMENTS) {
  const sentiment = sentiments.find((s) => s.Country === countryName);
  if (sentiment) {
    return getSentimentColorForTone(sentiment.Tone);
  }
  return colors.map.land;
}

export function getMarkerColorForRisk(riskScore) {
  if (riskScore >= 70) return colors.danger[500];
  if (riskScore >= 50) return colors.warning[500];
  if (riskScore >= 30) return colors.info[500];
  return colors.success[500];
}

export function getRiskBarClass(score) {
  if (score >= 70) return 'bg-danger-500';
  if (score >= 50) return 'bg-warning-500';
  return 'bg-success-500';
}

export function getRiskSoftClass(score) {
  if (score >= 70) return 'bg-danger-500/10 border-danger-500/30 text-danger-500';
  if (score >= 50) return 'bg-warning-500/10 border-warning-500/30 text-warning-500';
  return 'bg-success-500/10 border-success-500/30 text-success-500';
}

export function getAlertBorderClass(severity) {
  if (severity === 'critical') return 'border-l-danger-500';
  if (severity === 'high') return 'border-l-warning-500';
  return 'border-l-info-500';
}
